import React, { useState } from "react";
import "../styles/navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* LOGO */}
        <div className="nav-logo">
          <div className="logo-circle">
            <img src="/WhatsApp Image 2026-01-28 at 9.57.30 PM.jpeg" alt="logo" />
          </div>
          <span>HomoDial Healthcare </span>
        </div>

        {/* MENU ICON */}
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <div className={menuOpen ? "bar open" : "bar"}></div>
          <div className={menuOpen ? "bar open" : "bar"}></div>
          <div className={menuOpen ? "bar open" : "bar"}></div>
        </div>

        {/* NAV LINKS */}
        <ul className={menuOpen ? "nav-links active" : "nav-links"}>
          {["Home","About","Services","Testimonials","Contact"].map(
            (item, index) => (
              <li key={index}>
                <a href={"#" + item.toLowerCase()}>{item}</a>
              </li>
            )
          )}
        </ul>

      </div>
    </nav>
  );
}
